module.exports = __webpack_public_path__ + "static/media/SANGEET.a8dfa348.gif";